<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="id"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :itemNames="['search_name','search_status','create_button',]"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_name" label="店铺名称" v-bind="formItemLayout">
        <a-input v-model="queryParams.storeName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_status" label="状态" v-bind="formItemLayout">
        <a-select v-model="queryParams.onlineStatus" placeholder="请选择" allowClear style="width:100%;">
          <a-select-option :value="1">在线</a-select-option>
          <a-select-option :value="2">下线</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="onPageSearch">查 询</a-button>
        <a-button style="margin-left:15px" @click="dialogVisible = true">创建店铺</a-button>
        <a-button style="margin-left:15px" @click="openStoreApiDetail">API配置</a-button>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a @click="onEventStore(rowItem.record)">同步店铺</a>
        <a-divider type="vertical"/>
        <a @click="onEventUpload(rowItem.record)">资质上传</a>
      </template>
    </search-page-view>
    <a-modal title="创建店铺" :visible="dialogVisible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleCreateForm" ref="ruleCreateForm" :rules="createRules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="店铺名称" prop="storeName">
          <a-input v-model.trim="ruleCreateForm.storeName" placeholder="请输入店铺名称" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit('ruleCreateForm')" :loading="submitLoading">提交</a-button>
          <a-button @click="handleCancel" style="margin-left: 15px;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="同步店铺" :visible="visible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="店铺名称" prop="storeName">
          <a-input v-model.trim="ruleForm.storeName" placeholder="请输入店铺名称" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item label="POI ID" prop="poiId">
          <a-input v-model.trim="ruleForm.poiId" :disabled="isDisabled" placeholder="请输入poiId" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="onlineStatus">
          <a-select v-model="ruleForm.onlineStatus" placeholder="请选择" allowClear style="width:100%;">
            <a-select-option :value="1">在线</a-select-option>
            <a-select-option :value="2">下线</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit('ruleForm')" :loading="submitLoading">提交</a-button>
          <a-button @click="handleCancel" style="margin-left: 15px;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="API设置" :visible="popupVisible" width="750px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="dataForm" ref="dataForm" :rules="dataRules"
                    :label-col="currentFormLayout2.labelCol"
                    :wrapper-col="currentFormLayout2.wrapperCol"
      >
        <a-form-model-item label="clientKey" prop="clientKey">
          <a-input v-model.trim="dataForm.clientKey" placeholder="请输入clientKey" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item label="client_secret" prop="clientSecret">
          <a-input v-model.trim="dataForm.clientSecret" placeholder="请输入client_secret" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item label="app_id" prop="appId">
          <a-input v-model.trim="dataForm.appId" placeholder="请输入app_id" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item label="商家名" prop="accountName">
          <a-input v-model.trim="dataForm.accountName" placeholder="请输入商家名" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item label="平台公钥" prop="platformPublicKey">
          <a-textarea v-model="dataForm.platformPublicKey" :maxLength="10000" placeholder="请输入平台公钥"
                      :auto-size="{ minRows: 3, maxRows: 5 }"/>
        </a-form-model-item>
        <a-form-model-item label="应用公钥" v-if="dataForm.appPublicKey">
          <div class="line-font">{{ dataForm.appPublicKey }}</div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
          <a-button type="primary" @click="handleSubmit('dataForm')" :loading="submitLoading">提交</a-button>
          <a-button @click="handleCancel" style="margin-left: 15px;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal title="资质上传" :visible="uploadVisible" width="700px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleUploadForm" ref="ruleUploadForm" :rules="uploadRules"
                    :label-col="currentDialogLayout.labelCol"
                    :wrapper-col="currentDialogLayout.wrapperCol"
      >
        <a-form-model-item label="营业执照" prop="bizLicenceUrl" style="margin-bottom: 10px;">
          <div class="display-main">
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,1)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleUploadForm.bizLicenceUrl" :src="ruleUploadForm.bizLicenceUrl" alt="avatar"
                   class="selected-image"/>
              <div v-else>
                <a-icon :type="loadingBusiness? 'loading' : 'plus'"/>
              </div>
            </a-upload>
            <div class="line-text" v-if="ruleUploadForm.bizLicenceStatus">
              <span>审核状态：{{ ruleUploadForm.bizLicenceStatus|auditorFilterStatus }}</span><br/>
              <span v-if="ruleUploadForm.bizLicenceReason">{{ ruleUploadForm.bizLicenceReason }}</span>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="旅行社业务经营许可证" prop="travelBusinessLicenseUrl" style="margin-bottom: 10px;">
          <div class="display-main">
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,3)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleUploadForm.travelBusinessLicenseUrl" :src="ruleUploadForm.travelBusinessLicenseUrl"
                   alt="avatar" class="selected-image"/>
              <div v-else>
                <a-icon :type="loadingBusinessLicense? 'loading' : 'plus'"/>
              </div>
            </a-upload>
            <div class="line-text" v-if="ruleUploadForm.travelBusinessLicenseStatus">
              <span>审核状态：{{ ruleUploadForm.travelBusinessLicenseStatus|auditorFilterStatus }}</span><br/>
              <span
                v-if="ruleUploadForm.travelBusinessLicenseReason">{{ ruleUploadForm.travelBusinessLicenseReason }}</span>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="旅行社责任险保险单" prop="travelLiabilityInsurancePolicyUrl"
                           style="margin-bottom: 10px;">
          <div class="display-main">
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,4)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleUploadForm.travelLiabilityInsurancePolicyUrl"
                   :src="ruleUploadForm.travelLiabilityInsurancePolicyUrl" alt="avatar" class="selected-image"/>
              <div v-else>
                <a-icon :type="loadingInsurancePolicy? 'loading' : 'plus'"/>
              </div>
            </a-upload>
            <div class="line-text" v-if="ruleUploadForm.travelLiabilityInsurancePolicyStatus">
              <span>审核状态：{{ ruleUploadForm.travelLiabilityInsurancePolicyStatus|auditorFilterStatus }}</span><br/>
              <span
                v-if="ruleUploadForm.travelLiabilityInsurancePolicyReason">{{ ruleUploadForm.travelLiabilityInsurancePolicyReason }}</span>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="授权书" prop="contractUrl" style="margin-bottom: 10px;">
          <div class="display-main">
            <a-upload
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo,2)"
              :before-upload="handleBeforeUploadImage"
            >
              <img v-if="ruleUploadForm.contractUrl" :src="ruleUploadForm.contractUrl" alt="avatar"
                   class="selected-image"/>
              <div v-else>
                <a-icon :type="loadingAuthor? 'loading' : 'plus'"/>
              </div>
            </a-upload>
            <div class="line-text" v-if="ruleUploadForm.contractStatus">
              <span>审核状态：{{ ruleUploadForm.contractStatus|auditorFilterStatus }}</span><br/>
              <span v-if="ruleUploadForm.contractReason">{{ ruleUploadForm.contractReason }}</span>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="选择日期" prop="selectDate">
          <a-date-picker v-model="ruleUploadForm.selectDate" @change="onDateChange" format="YYYY-MM-DD"
                         :disabled-date="disabledDate"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentDialogLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit('ruleUploadForm')" :loading="submitLoading">提交</a-button>
          <a-button @click="handleCancel" style="margin-left: 15px;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import TiktokMixins from '@/views/service/serviceProvider/tiktokHelper/mixins/TiktokMixins'
import moment from 'moment'

export default {
  name: 'TiktokStores',
  mixins: [TiktokMixins],
  components: {},
  data() {
    return {
      moment,
      submitLoading: false,
      dialogVisible: false,
      popupVisible: false,
      visible: false,
      ruleCreateForm: {
        storeName: ''
      },
      ruleForm: {
        id: '',//店铺id
        onlineStatus: '',//在线状态 1 - 在线; 2 - 下线
        poiId: '',//抖音POI
        storeName: ''//店铺名称
      },
      dataForm: {
        appId: '',//appId ,
        clientKey: '',// 应用key ,
        clientSecret: '',// 应用secret
        accountName: '',
        platformPublicKey: '',
        appPublicKey: ''
      },
      rules: {
        storeName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' }
        ],
        poiId: [
          { required: true, message: '请输入poiId', trigger: 'blur' }
        ],
        onlineStatus: [
          { required: true, message: '请选择店铺状态', trigger: 'change' }
        ]
      },
      dataRules: {
        clientKey: [
          { required: true, message: '请输入clientKey', trigger: 'blur' }
        ],
        clientSecret: [
          { required: true, message: '请输入client_secret', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入app_id', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入商家名', trigger: 'blur' }
        ]
      },
      createRules: {
        storeName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' }
        ]
      },
      queryParams: {
        onlineStatus: undefined
      },
      loadPromise: params => this.getListPromise(params),
      isDisabled: false,
      uploadVisible: false,
      loadingBusiness: false,
      loadingAuthor: false,
      loadingBusinessLicense: false,
      loadingInsurancePolicy: false,
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      ruleUploadForm: {
        bizLicenceUrl: '',
        contractUrl: '',
        expireDate: '',
        id: 0,
        selectDate: undefined,
        bizLicenceReason: '',
        contractReason: '',
        contractStatus: '',
        bizLicenceStatus: '',
        travelBusinessLicenseUrl: '',//旅行社业务经营许可证
        travelBusinessLicenseStatus: '',//旅行社业务经营许可证，1:审核中，2:审核成功，3：审核失败")
        travelBusinessLicenseReason: '',//旅行社业务经营许可证 审核失败原因")
        travelLiabilityInsurancePolicyUrl: '',//"旅行社责任险保险单
        travelLiabilityInsurancePolicyStatus: '',//旅行社责任险保险单，1:审核中，2:审核成功，3：审核失败
        travelLiabilityInsurancePolicyReason: ''//旅行社责任险保险单 审核失败原因
      },
      uploadRules: {
        bizLicenceUrl: [
          { required: true, message: '请上传营业执照', trigger: ['blur', 'change'] }
        ],
        travelBusinessLicenseUrl: [
          { required: true, message: '请上传旅行社业务经营许可证', trigger: ['blur', 'change'] }
        ],
        travelLiabilityInsurancePolicyUrl: [
          { required: true, message: '请上旅行社责任险保险单', trigger: ['blur', 'change'] }
        ],
        contractUrl: [
          { required: true, message: '请上传授权书', trigger: ['blur', 'change'] }
        ],
        selectDate: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    onPageSearch() {
      this.$refs.table.refresh(true)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getProService().post('api/douyin/helper/store/listPage', params)
    },
    handleCancel() {
      this.dialogVisible = false
      this.popupVisible = false
      this.visible = false
      this.uploadVisible = false
    },
    handleSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (form == 'dataForm') {
            this.getLogUtils().logWithTag('API设置', form)
            this.submitConfigData()
          } else if (form == 'ruleCreateForm') {
            this.submitStoreData()
            this.getLogUtils().logWithTag('创建店铺', form)
          } else if (form == 'ruleForm') {
            this.getLogUtils().logWithTag('同步店铺', form)
            this.submitSyncStoreData()
          } else {
            this.getLogUtils().logWithTag('资质上传', form)
            this.submitUploadData()
          }
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //同步店铺
    submitSyncStoreData() {
      this.submitLoading = true
      const params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices().getProService().post('api/douyin/helper/store/sync', params).then(res => {
        this.getLogUtils().logWithTag('submitSyncStoreData', res)
        this.$message.success('同步店铺成功')
        this.handleCancel()
        this.onPageSearch()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 创建店铺
    submitStoreData() {
      this.submitLoading = true
      const params = JSON.parse(JSON.stringify(this.ruleCreateForm))
      this.getHttpServices().getProService().post('/api/douyin/helper/store/add', params).then(res => {
        this.getLogUtils().logWithTag('submitStoreData', res)
        this.$message.success('创建店铺成功')
        this.handleCancel()
        this.onPageSearch()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // api设置
    submitConfigData() {
      this.submitLoading = true
      const params = JSON.parse(JSON.stringify(this.dataForm))
      delete params.appPublicKey
      this.getHttpServices().getProService().post('api/douyin/helper/config/save', params).then(res => {
        this.getLogUtils().logWithTag('submitConfigData', res)
        this.$message.success('API配置成功')
        this.handleCancel()
        this.onPageSearch()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 资质上传
    submitUploadData() {
      this.submitLoading = true
      const params = JSON.parse(JSON.stringify(this.ruleUploadForm))
      delete params.selectDate
      this.getHttpServices().getProService().post('api/douyin/helper/uploadStoreMaterial', params).then(res => {
        this.getLogUtils().logWithTag('submitUploadData', res)
        this.$message.success('资质上传成功')
        this.handleCancel()
        this.onPageSearch()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    onEventStore(record) {
      this.visible = true
      this.ruleForm.id = record.id//店铺id
      this.ruleForm.onlineStatus = record.onlineStatus
      this.ruleForm.poiId = record.poiId ? record.poiId : ''///抖音POI
      this.isDisabled = record.poiId ? true : false
      this.ruleForm.storeName = record.storeName///店铺名称
    },
    // API设置回显
    openStoreApiDetail() {
      this.popupVisible = true
      this.getHttpServices().getProService().post('api/douyin/helper/config/detail').then(res => {
        if (res && res.appId) {
          this.dataForm = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //文件变更监听
    handleChange(fileInfo, index) {
      if (fileInfo.file.status === 'uploading') {
        if (index === 1) {
          this.loadingBusiness = true
        } else if (index === 2) {
          this.loadingAuthor = true
        } else if (index === 3) {
          this.loadingBusinessLicense = true
        } else if (index === 4) {
          this.loadingInsurancePolicy = true
        }
      } else if (fileInfo.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(fileInfo.fileList)
        if (index === 1) {
          this.ruleUploadForm.bizLicenceUrl = url
          this.loadingBusiness = false
          this.$refs.ruleUploadForm.validateField('bizLicenceUrl', (Error) => {
          })
        } else if (index === 2) {
          this.ruleUploadForm.contractUrl = url
          this.$refs.ruleUploadForm.validateField('contractUrl', (Error) => {
          })
          this.loadingAuthor = false
        } else if (index === 3) {
          this.ruleUploadForm.travelBusinessLicenseUrl = url
          this.$refs.ruleUploadForm.validateField('travelBusinessLicenseUrl', (Error) => {
          })
          this.loadingBusinessLicense = false
        } else if (index === 4) {
          this.ruleUploadForm.travelLiabilityInsurancePolicyUrl = url
          this.$refs.ruleUploadForm.validateField('travelLiabilityInsurancePolicyUrl', (Error) => {
          })
          this.loadingInsurancePolicy = false
        }
      }
    },
    onEventUpload(record) {
      this.uploadVisible = true
      this.ruleUploadForm.id = record.id
      this.getStoreMaterial(record.id)
    },
    getStoreMaterial(id) {
      const params = { id }
      this.getHttpServices().getProService().post('api/douyin/helper/getStoreMaterial', params).then(res => {
        this.ruleUploadForm = { ...res }
        this.ruleUploadForm.bizLicenceUrl = res.bizLicenceUrl ? res.bizLicenceUrl : ''
        this.ruleUploadForm.contractUrl = res.contractUrl ? res.contractUrl : ''
        this.ruleUploadForm.travelLiabilityInsurancePolicyUrl = res.travelLiabilityInsurancePolicyUrl ? res.travelLiabilityInsurancePolicyUrl : ''
        this.ruleUploadForm.travelBusinessLicenseUrl = res.travelBusinessLicenseUrl ? res.travelBusinessLicenseUrl : ''
        this.ruleUploadForm.selectDate = res.expireDate ? moment(res.expireDate, 'YYYY-MM-DD') : undefined
        this.ruleUploadForm.expireDate = res.expireDate ? res.expireDate : ''
        this.ruleUploadForm = { ...this.ruleUploadForm }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDateChange(date, dateString) {
      this.ruleUploadForm.selectDate = date
      this.ruleUploadForm.expireDate = dateString
      this.ruleUploadForm = { ...this.ruleUploadForm }
    },
    getColumns() {
      return [
        {
          title: '店铺ID',
          dataIndex: 'id'
        },
        {
          title: '店铺名称',
          dataIndex: 'storeName'
        },
        {
          title: '状态',
          dataIndex: 'onlineStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '170px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
.right-box {
  text-align: right;
}

.line-font {
  padding-top: 5px;
  line-height: 28px;
}

.selected-image {
  width: 86px;
  height: 86px;
}

.display-main {
  display: flex;
  align-items: center;

  .line-text {
    flex-shrink: 0;
    width: 345px;
    line-height: 18px;
    font-size: 14px;
  }
}
</style>